module.exports = __webpack_public_path__ + "static/img/img-ptfw3x.52cd5d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw3x.png
// module id = rT9i
// module chunks = 0